import { takeLatest, put, call, all } from "redux-saga/effects";

import {
  GET_LOYALTY_LIST,
  GET_LOYALTY_LIST_SUCCESS,
  GET_LOYALTY_LIST_ERROR,
  LOYALTY_SINGLE_CUSTOMER_DATA,
  LOYALTY_SINGLE_CUSTOMER_DATA_SUCCESS,
  LOYALTY_SINGLE_CUSTOMER_DATA_ERROR,
  LOYALTY_SINGLE_CUSTOMER_BALANCE_SEARCH,
  LOYALTY_SINGLE_CUSTOMER_BALANCE_SEARCH_SUCCESS,
  LOYALTY_SINGLE_CUSTOMER_BALANCE_SEARCH_ERROR,
  GET_LOYALTY_BALANCES_LIST,
  GET_LOYALTY_BALANCES_LIST_SUCCESS,
  GET_LOYALTY_BALANCES_LIST_ERROR,
  GET_LOYALTY_VOUCHERS_LIST,
  GET_LOYALTY_VOUCHERS_LIST_SUCCESS,
  GET_LOYALTY_VOUCHERS_LIST_ERROR,
  GET_LOYALTY_DASHBOARD_RECENT_ACTIVITY_LIST,
  GET_LOYALTY_DASHBOARD_RECENT_ACTIVITY_LIST_SUCCESS,
  GET_LOYALTY_DASHBOARD_RECENT_ACTIVITY_LIST_ERROR,
  SEARCH_LOYALTY_DASHBOARD_REPORT_DATA,
  SEARCH_LOYALTY_DASHBOARD_REPORT_DATA_SUCCESS,
  SEARCH_LOYALTY_DASHBOARD_REPORT_DATA_ERROR,
  CREATE_LOYALTY_TRANSACTION,
  CREATE_LOYALTY_TRANSACTION_SUCCESS,
  CREATE_LOYALTY_TRANSACTION_ERROR,
  CREATE_LOYALTY_VOUCHER_AMOUNT,
  CREATE_LOYALTY_VOUCHER_AMOUNT_SUCCESS,
  CREATE_LOYALTY_VOUCHER_AMOUNT_ERROR,
  LOYALTY_REDEEM_VOUCHER,
  LOYALTY_REDEEM_VOUCHER_SUCCESS,
  LOYALTY_REDEEM_VOUCHER_ERROR,
  VOID_VOUCHER_TRANSACTION,
  RESEND_LOYALTY_VOUCHER_EMAIL,
  LOYALTY_SINGLE_CUSTOMER_VOUCHER_LIST,
  GET_LOYALTY_SPINNER_LIST,
  CREATE_LOYALTY_SPINNER,
  UPDATE_LOYALTY_SPINNER,
  DELETE_LOYALTY_SPINNER,
  GET_LOYALTY_SPINNER_RENDER,
  GET_LOYALTY_SPINNER_DATA,
  EXECUTE_LOYALTY_SPINNER,
} from "./actionType";

import {
  getLoyaltyListSuccess,
  getLoyaltyListError,
  getLoyaltySingleCustomerDataSuccess,
  getLoyaltySingleCustomerDataError,
  getLoyaltySingleCustomerBalanceSearchSuccess,
  getLoyaltySingleCustomerBalanceSearchError,
  getLoyaltyBalancesListSuccess,
  getLoyaltyBalancesListError,
  getLoyaltyVouchersListSuccess,
  getLoyaltyVouchersListError,
  getLoyaltyDashboardRecentActivityListSuccess,
  getLoyaltyDashboardRecentActivityListError,
  searchLoyaltyDashboardReportDataSuccess,
  searchLoyaltyDashboardReportDataError,
  createLoyaltyTransactionSuccess,
  createLoyaltyTransactionError,
  createLoyaltyVoucherAmountSuccess,
  createLoyaltyVoucherAmountError,
  loyaltyRedeemVoucherSuccess,
  loyaltyRedeemVoucherError,
  voidVoucherTransactionSuccess,
  voidVoucherTransactionError,
  resendLoyaltyVoucherEmailSuccess,
  resendLoyaltyVoucherEmailError,
  getLoyaltySingleCustomerVoucherListSuccess,
  getLoyaltySingleCustomerVoucherListError,
  getLoyaltySpinnerListSuccess,
  getLoyaltySpinnerListError,
  createLoyaltySpinnerSuccess,
  createLoyaltySpinnerError,
  updateLoyaltySpinnerSuccess,
  updateLoyaltySpinnerError,
  deleteLoyaltySpinnerSuccess,
  deleteLoyaltySpinnerError,
  getLoyaltySpinnerRenderSuccess,
  getLoyaltySpinnerRenderError,
  getLoyaltySpinnerDataSuccess,
  getLoyaltySpinnerDataError,
  executeLoyaltySpinnerSuccess,
  executeLoyaltySpinnerError,
} from "./action";

import {
  getLoyaltyListApiCall,
  getLoyaltySingleCustomerApiCall,
  getLoyaltySingleCustomerBalanceSearchApiCall,
  getLoyaltyBalancesListApiCall,
  getLoyaltyVouchersListApiCall,
  getLoyaltyDashboardRecentActivityApiCall,
  getLoyaltyDashboardReportDataSearchApiCall,
  createLoyaltyTransactionApiCall,
  createLoyaltyVoucherAmountApiCall,
  redeemLoyaltyVoucherAmountApiCall,
  voidVoucherApiCall,
  resendLoyaltyVoucherApiCall,
  getLoyaltySingleCustomerVoucherListApiCall,
  getLoyaltySpinnerListApiCall,
  createLoyaltySpinnerApiCall,
  updateLoyaltySpinnerApiCall,
  deleteLoyaltySpinnerApiCall,
  getLoyaltySpinnerRenderApiCall,
  getLoyaltySpinnerDataApiCall,
  executeLoyaltySpinnerApiCall,
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";

// Saga for Loyalty List and CRUD

// Loyalty List
export function* getLoyaltyListItems() {
  try {
    const response = yield call(getLoyaltyListApiCall);
    yield put(getLoyaltyListSuccess(response));
  } catch (error) {
    yield put(getLoyaltyListError(error));
  }
}

export function* watchGetLoyaltyList() {
  yield takeLatest(GET_LOYALTY_LIST, getLoyaltyListItems);
}

// Loalty get single customer data post request

export function* getLoyaltySingleCustomerDataItems({ payload }) {
  try {
    const response = yield call(getLoyaltySingleCustomerApiCall, payload);
    yield put(getLoyaltySingleCustomerDataSuccess(response));
  } catch (error) {
    yield put(getLoyaltySingleCustomerDataError(error));
  }
}

export function* watchGetLoyaltySingleCustomerData() {
  yield takeLatest(
    LOYALTY_SINGLE_CUSTOMER_DATA,
    getLoyaltySingleCustomerDataItems
  );
}

// Loyalty Single Customer balance Search

export function* getLoyaltySingleCustomerBalanceSearchItems({ payload }) {
  try {
    const response = yield call(
      getLoyaltySingleCustomerBalanceSearchApiCall,
      payload
    );
    yield put(getLoyaltySingleCustomerBalanceSearchSuccess(response));
  } catch (error) {
    yield put(getLoyaltySingleCustomerBalanceSearchError(error));
  }
}

export function* watchGetLoyaltySingleCustomerBalanceSearch() {
  yield takeLatest(
    LOYALTY_SINGLE_CUSTOMER_BALANCE_SEARCH,
    getLoyaltySingleCustomerBalanceSearchItems
  );
}

// GET Loyalty Balances List

export function* getLoyaltyBalancesListItems() {
  try {
    const response = yield call(getLoyaltyBalancesListApiCall);
    yield put(getLoyaltyBalancesListSuccess(response));
  } catch (error) {
    yield put(getLoyaltyBalancesListError(error));
  }
}

export function* watchGetLoyaltyBalancesList() {
  yield takeLatest(GET_LOYALTY_BALANCES_LIST, getLoyaltyBalancesListItems);
}

// GET Loyalty Vouchers List

export function* getLoyaltyVouchersListItems() {
  try {
    const response = yield call(getLoyaltyVouchersListApiCall);
    yield put(getLoyaltyVouchersListSuccess(response));
  } catch (error) {
    yield put(getLoyaltyVouchersListError(error));
  }
}

export function* watchGetLoyaltyVouchersList() {
  yield takeLatest(GET_LOYALTY_VOUCHERS_LIST, getLoyaltyVouchersListItems);
}

// GET Loyalty Dashboard Recent Activity List

export function* getLoyaltyDashboardRecentActivityListItems() {
  try {
    const response = yield call(getLoyaltyDashboardRecentActivityApiCall);
    yield put(getLoyaltyDashboardRecentActivityListSuccess(response));
  } catch (error) {
    yield put(getLoyaltyDashboardRecentActivityListError(error));
  }
}

export function* watchGetLoyaltyDashboardRecentActivityList() {
  yield takeLatest(
    GET_LOYALTY_DASHBOARD_RECENT_ACTIVITY_LIST,
    getLoyaltyDashboardRecentActivityListItems
  );
}

// GET Loyalty Dashboard Report Data Search

export function* searchLoyaltyDashboardReportDataItems({ payload }) {
  try {
    const response = yield call(
      getLoyaltyDashboardReportDataSearchApiCall,
      payload
    );
    yield put(searchLoyaltyDashboardReportDataSuccess(response));
  } catch (error) {
    yield put(searchLoyaltyDashboardReportDataError(error));
  }
}

export function* watchGetLoyaltyDashboardReportDataSearch() {
  yield takeLatest(
    SEARCH_LOYALTY_DASHBOARD_REPORT_DATA,
    searchLoyaltyDashboardReportDataItems
  );
}

// Create Loyalty Transaction

export function* createLoyaltyTransactionItems({ payload }) {
  try {
    const response = yield call(createLoyaltyTransactionApiCall, payload);
    yield put(createLoyaltyTransactionSuccess(response));
  } catch (error) {
    yield put(createLoyaltyTransactionError(error));
  }
}

export function* watchCreateLoyaltyTransaction() {
  yield takeLatest(CREATE_LOYALTY_TRANSACTION, createLoyaltyTransactionItems);
}

// Create Loyalty Voucher Amount

export function* createLoyaltyVoucherAmountItems({ payload }) {
  try {
    const response = yield call(createLoyaltyVoucherAmountApiCall, payload);
    yield put(createLoyaltyVoucherAmountSuccess(response));
  } catch (error) {
    yield put(createLoyaltyVoucherAmountError(error));
  }
}

export function* watchCreateLoyaltyVoucherAmount() {
  yield takeLatest(
    CREATE_LOYALTY_VOUCHER_AMOUNT,
    createLoyaltyVoucherAmountItems
  );
}
// Redeem Loyalty Voucher Amount

export function* redeemLoyaltyVoucherAmountItems({ payload }) {
  try {
    const response = yield call(redeemLoyaltyVoucherAmountApiCall, payload);
    yield put(loyaltyRedeemVoucherSuccess(response));
  } catch (error) {
    yield put(loyaltyRedeemVoucherError(error));
  }
}

export function* watchRedeemLoyaltyVoucherAmount() {
  yield takeLatest(LOYALTY_REDEEM_VOUCHER, redeemLoyaltyVoucherAmountItems);
}

// Loyalty  Void Voucher Transaction api call

export function* voidLoyaltyVoucherTransactionItems({ payload }) {
  try {
    const response = yield call(voidVoucherApiCall, payload);
    yield put(voidVoucherTransactionSuccess(response));
  } catch (error) {
    yield put(voidVoucherTransactionError(error));
  }
}

export function* watchVoidLoyaltyVoucherTransaction() {
  yield takeLatest(
    VOID_VOUCHER_TRANSACTION,
    voidLoyaltyVoucherTransactionItems
  );
}
// Loyalty Resend EMail APi Call

export function* resendLoyaltyEmailItems({ payload }) {
  try {
    const response = yield call(resendLoyaltyVoucherApiCall, payload);
    yield put(resendLoyaltyVoucherEmailSuccess(response));
  } catch (error) {
    yield put(resendLoyaltyVoucherEmailError(error));
  }
}

export function* watchResendLoyaltyEmail() {
  yield takeLatest(RESEND_LOYALTY_VOUCHER_EMAIL, resendLoyaltyEmailItems);
}
// Loyalty  Single Customer Voucher List

export function* getLoyaltySingleCustomerVoucherListItems({ payload }) {
  try {
    const response = yield call(
      getLoyaltySingleCustomerVoucherListApiCall,
      payload
    );
    yield put(getLoyaltySingleCustomerVoucherListSuccess(response));
  } catch (error) {
    yield put(getLoyaltySingleCustomerVoucherListError(error));
  }
}

export function* watchGetLoyaltySingleCustomerVoucherList() {
  yield takeLatest(
    LOYALTY_SINGLE_CUSTOMER_VOUCHER_LIST,
    getLoyaltySingleCustomerVoucherListItems
  );
}

// Loyalty Spinner List
export function* getLoyaltySpinnerListItems() {
  try {
    const response = yield call(getLoyaltySpinnerListApiCall);
    yield put(getLoyaltySpinnerListSuccess(response));
  } catch (error) {
    yield put(getLoyaltySpinnerListError(error));
  }
}

export function* watchGetLoyaltySpinnerList() {
  yield takeLatest(GET_LOYALTY_SPINNER_LIST, getLoyaltySpinnerListItems);
}

// Create Loyalty Spinner
export function* createLoyaltySpinnerItems({ payload }) {
  try {
    const response = yield call(createLoyaltySpinnerApiCall, payload);
    yield put(createLoyaltySpinnerSuccess(response));
  } catch (error) {
    yield put(createLoyaltySpinnerError(error));
  }
}

export function* watchCreateLoyaltySpinner() {
  yield takeLatest(CREATE_LOYALTY_SPINNER, createLoyaltySpinnerItems);
}

// Update Loyalty Spinner
export function* updateLoyaltySpinnerItems({ payload }) {
  try {
    const response = yield call(updateLoyaltySpinnerApiCall, payload);
    yield put(updateLoyaltySpinnerSuccess(response));
  } catch (error) {
    yield put(updateLoyaltySpinnerError(error));
  }
}

export function* watchUpdateLoyaltySpinner() {
  yield takeLatest(UPDATE_LOYALTY_SPINNER, updateLoyaltySpinnerItems);
}

// Delete Loyalty Spinner
export function* deleteLoyaltySpinnerItems({ payload }) {
  try {
    const response = yield call(deleteLoyaltySpinnerApiCall, payload);
    yield put(deleteLoyaltySpinnerSuccess(response));
  } catch (error) {
    yield put(deleteLoyaltySpinnerError(error));
  }
}

export function* watchDeleteLoyaltySpinner() {
  yield takeLatest(DELETE_LOYALTY_SPINNER, deleteLoyaltySpinnerItems);
}

// Get Loyalty Spinner Render Data
export function* getLoyaltySpinnerRenderItems({ payload }) {
  try {
    const response = yield call(getLoyaltySpinnerRenderApiCall, payload);
    yield put(getLoyaltySpinnerRenderSuccess(response));
  } catch (error) {
    yield put(getLoyaltySpinnerRenderError(error));
  }
}

export function* watchGetLoyaltySpinnerRender() {
  yield takeLatest(GET_LOYALTY_SPINNER_RENDER, getLoyaltySpinnerRenderItems);
}

// Get Loyalty Spinner Data
export function* getLoyaltySpinnerDataItems({ payload }) {
  try {
    const response = yield call(getLoyaltySpinnerDataApiCall, payload);
    yield put(getLoyaltySpinnerDataSuccess(response));
  } catch (error) {
    yield put(getLoyaltySpinnerDataError(error));
  }
}

export function* watchGetLoyaltySpinnerData() {
  yield takeLatest(GET_LOYALTY_SPINNER_DATA, getLoyaltySpinnerDataItems);
}

// Execute Loyalty Spinner
export function* executeLoyaltySpinnerItems({ payload }) {
  try {
    const response = yield call(executeLoyaltySpinnerApiCall, payload);
    yield put(executeLoyaltySpinnerSuccess(response));
  } catch (error) {
    yield put(executeLoyaltySpinnerError(error));
  }
}

export function* watchExecuteLoyaltySpinner() {
  yield takeLatest(EXECUTE_LOYALTY_SPINNER, executeLoyaltySpinnerItems);
}

// Loyalty Root Saga

function* Loyalty() {
  yield all([
    call(watchGetLoyaltyList),
    call(watchGetLoyaltySingleCustomerData),
    call(watchGetLoyaltySingleCustomerBalanceSearch),
    call(watchGetLoyaltyBalancesList),
    call(watchGetLoyaltyVouchersList),
    call(watchGetLoyaltyDashboardRecentActivityList),
    call(watchGetLoyaltyDashboardReportDataSearch),
    call(watchCreateLoyaltyTransaction),
    call(watchCreateLoyaltyVoucherAmount),
    call(watchRedeemLoyaltyVoucherAmount),
    call(watchVoidLoyaltyVoucherTransaction),
    call(watchResendLoyaltyEmail),
    call(watchGetLoyaltySingleCustomerVoucherList),
    call(watchGetLoyaltySpinnerList),
    call(watchCreateLoyaltySpinner),
    call(watchUpdateLoyaltySpinner),
    call(watchDeleteLoyaltySpinner),
    call(watchGetLoyaltySpinnerRender),
    call(watchGetLoyaltySpinnerData),
    call(watchExecuteLoyaltySpinner),
  ]);
}

export default Loyalty;
